import type { ReactNode } from "react";
import "./ui.css";

interface SurfaceCardProps {
	children: ReactNode;
	onClick?: () => void;
	className?: string;
	isActive?: boolean;
	/** An anchor to scroll to, as the Accounting Health tiles do. */
	id?: string;
}

/* Chose NOT to wrap MetricCard: MetricCard is an opinionated KPI tile
   (AntD Card + Statistic + trend), whereas SurfaceCard is a bare editorial
   surface (the .firm-stat-card / .firm-roster shell) meant to hold arbitrary
   content. Wrapping MetricCard would drag in its borderLeft/Statistic layout. */
export function SurfaceCard({
	children,
	onClick,
	className,
	isActive,
	id,
}: SurfaceCardProps) {
	const classes = [
		"ui-surface-card",
		onClick ? "is-clickable" : "",
		isActive ? "is-active" : "",
		className ?? "",
	]
		.filter(Boolean)
		.join(" ");

	if (onClick) {
		return (
			<button type="button" id={id} className={classes} onClick={onClick}>
				{children}
			</button>
		);
	}

	return (
		<div id={id} className={classes}>
			{children}
		</div>
	);
}
